export default {
    videoNotLoaded: "Vidéo non disponible dans votre navigateur",
    next: "Suivant",
    previous: "Précédent",
    skipAll: "Passer",
    finish: "Terminer",
    skipTutorial: "Passer le tutoriel",
    startTutorial: "Démarrer le tutoriel",
    welcome: {
        title: "Bienvenue à bord!",
        subtitle:
            "Ce guide rapide ne prend que 2 minutes, il vous aidera à vous familiariser avec la plateforme en quelques étapes seulement.",
        describe:
            "C'est un monde virtuel où les équipes se rencontrent, discutent et collaborent naturellement",
        describe2: " — comme dans la vraie vie.",
        describe3: "Dans ce tutoriel, vous apprendrez à :",
        bloc1: "Se déplacer",
        bloc2: "Parlez avec les autres",
        bloc3: "Découvrez des objets interactifs",
    },
    step1: {
        title: "Explorez votre monde",
        use: "Utilisez les",
        arrowkeys: "flèches directionnelles",
        or: "ou ",
        wasd: "ZQSD pour déplacer votre avatar",
        aroundTheMap: " sur la carte. Essayez-le maintenant !",
        tip: "Astuce:",
        describeTip:
            " maintenez la touche Maj enfoncée pendant que vous vous déplacez pour marcher plus vite — parfait si vous êtes en retard ou si vous souhaitez explorer plus rapidement !",
        silentZone:
            "Vous êtes actuellement dans une zone silencieuse — ici, personne ne peut vous entendre.",
    },
    step2: {
        title: "Parlez & collaborez",
        describe: "Pour démarrer une conversation, approchez-vous de quelqu'un",
        describe2: " — la vidéo ou l'audio se lancera automatiquement.",
        describe3:
            "Cliquez sur l'icône du cadenas pour verrouiller la conversation et la rendre privée.",
        describe4:
            "Cliquez sur le bouton « Partager l'écran » pendant une conversation pour afficher votre écran",
    },
    step3: {
        title: "Découvrez & interagissez",
        interact: "Interagissez avec des objets ",
        likeSign: " tels que des panneaux, des écrans, des documents et des portails",
        sometimes: "— parfois ils s'allument quand on s'approche.",
        closer: "quand on s'approche.",
        describe3:
            "Réunissez les gens dans des salles de réunion, favorisant les discussions spontanées et le travail d'équipe.",
        describe4:
            "Faites une pause dans des zones silencieuses, l'endroit idéal pour vous concentrer et travailler sans interruption.",
    },
};
